import React from 'react';
import PropTypes from 'prop-types';
import RequiredFieldAsterisk from './RequiredAsterisk';

/**
 * Component to format phone inputs
 * @prop form_name - Name for integration with Rails form submission
 * @prop input_id  - ID for the HTML input element
 * @prop change    - callback function to update state
 * @prop helpText  - help text for input
 */
export default class PhoneInput extends React.Component {
  validCharacters = ['+', '-', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  checkTextSelected = (input) => input.selectionStart !== input.selectionEnd

  handleInput = (e) => {
    if (!this.validCharacters.includes(e.key)) {
      // if it's not an integer, a plus sign, or a hyphen, don't allow entry
      e.preventDefault();
    }
  }

  render() {
    const {
      helpText,
      label,
      form_name: formName,
      input_id: inputId,
      inputClass,
      change,
      value,
      required,
    } = this.props;

    return (
      <div className="field input-container">
        <label
          className="label label--newline"
          htmlFor={inputId}
        >
          { label }
          {required && (
            <>
              {' '}
              <RequiredFieldAsterisk />
            </>
          )}
        </label>
        <p className="help-text" style={{ fontSize: '0.9rem' }}>{helpText}</p>
        <input
          type="tel"
          name={formName}
          id={inputId}
          className={`input ${inputClass}`}
          onKeyPress={this.handleInput}
          onChange={change}
          value={value}
          required={required}
        />
      </div>
    );
  }
}

PhoneInput.propTypes = {
  form_name: PropTypes.string.isRequired,
  input_id: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  helpText: PropTypes.string,
  value: PropTypes.string,
  inputClass: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.string,
};

PhoneInput.defaultProps = {
  helpText: '',
  value: '',
  inputClass: '',
  required: false,
  label: 'Phone',
};
